import type { FaireProductEntity } from "../../entity_types/product";

export const p_atuz6gjfbe: FaireProductEntity = {
  token: "p_atuz6gjfbe",
  type: "product",
  name: "Strawberry Cupcake Bath Treats (3 pc bath bomb set)",
  brandToken: "b_arfo4zvzts",
  brandName: "NCLA Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/659308f4e7fd46924b7f5910097fce6728413bd070448c80cc7c348f91179d23.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d81b55d7ca4e3d51395346c28ad5a65938b51d125e9bda10ef5579fa3a7c0ede.jpeg",
    "https://cdn.faire.com/fastly/ecc1fcdfa9a2bb262ae0b3ab01770c5b6be6d4cd7dfe0cec63b4ca3b020cbbc8.jpeg",
    "https://cdn.faire.com/fastly/46471629aa927df4a71be16415844072ef34e90e5944c808e7fae4afe494fcf3.jpeg",
    "https://cdn.faire.com/fastly/63132e03f10babe2c4d58417bd3e03e20eba0688b661b3222dddf9ff379a678c.jpeg",
    "https://cdn.faire.com/fastly/3339828c51b29384c76471663229a91b6fa0862fc0a4a741a7cc782452190f6b.jpeg",
  ],
  priceDollars: 9,
  description:
    "A hand made bath bomb trio that will leave skin ultra soft and smelling delicious! Sit back, fizz, and relax! Each set comes with 3 donut shaped bath treats made with nourishing, skin-soothing, and hydrating ingredients like epsom salt, kaolin clay, and shea butter. It's also infused with an essential oil blend to bring an aromatherapeutic experience to your bath time.\n\n𝗜𝗻𝗴𝗿𝗲𝗱𝗶𝗲𝗻𝘁𝘀:\nSodium Bicarbonate, Citric Acid, Organic Shea Butter, White Kaolin Clay, Essential Oil Blend, Polysorbate 80, Isopropyl Alcohol, Epsom Salt, Mica-Colorant",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:57.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
